registerComponent("pages/not-found", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Sem comportamento próprio, em 2020 e hoje. A página é só LESS.
 */

});
